import { API_BASE_URL } from "@kupikupi/brand";
import { useQuery } from "@tanstack/react-query";
import { getWarehouseDefaultAddress } from "../endpoints/address";
import type { AddressVo } from "../types/address";

const WAREHOUSE_ADDRESS_KEY = ["addresses", "warehouse-default"] as const;

/**
 * Default transit-warehouse receiving address. Public/anon —
 * no JWT required — so it loads on the confirm-order page regardless of auth
 * state. Cached aggressively since the warehouse address rarely changes (#180).
 */
export function useWarehouseAddress() {
  return useQuery<AddressVo>({
    queryKey: WAREHOUSE_ADDRESS_KEY,
    queryFn: () => getWarehouseDefaultAddress({ baseUrl: API_BASE_URL }),
    staleTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
